module.exports = __webpack_public_path__ + "img/ic_idiom.6e01cca3.png";